<template>
  <div id="login">
    <transition name="fade">
      <div v-if="performingRequest" class="loading">
        <p>Loading...</p>
      </div>
    </transition>
    <section>
      <div
        class="col2"
        :class="{ 'signup-form': !showLoginForm && !showForgotPassword }"
      >
        <form v-if="showLoginForm" @submit.prevent>
          <h1 style="margin-bottom:50px;color:#1abc9c">ListWorks</h1>
          <!-- TODO: Add logo here instead -->

          <label for="email1">Email</label>
          <v-text-field
            v-model.trim="loginForm.email"
            type="text"
            placeholder="you@email.com"
            id="email1"
          />

          <label for="password1">Password</label>
          <v-text-field
            v-model.trim="loginForm.password"
            type="password"
            placeholder="******"
            id="password1"
          />

          <button @click="login" class="button">Log In</button>

          <div class="extras">
            <a @click="togglePasswordReset">Forgot Password</a>
          </div>
        </form>
        <form v-if="!showLoginForm && !showForgotPassword" @submit.prevent>
          <h1>Get Started</h1>

          <label for="name">Name</label>
          <v-text-field
            v-model.trim="signupForm.name"
            type="text"
            placeholder="Username"
            id="name"
          />

          <label for="email2">Email</label>
          <v-text-field
            v-model.trim="signupForm.email"
            type="text"
            placeholder="you@email.com"
            id="email2"
          />

          <label for="password2">Password</label>
          <v-text-field
            v-model.trim="signupForm.password"
            type="password"
            placeholder="min 6 characters"
            id="password2"
          />

          <button @click="signup" class="button">Sign Up</button>

          <div class="extras">
            <a @click="toggleForm">Back to Log In</a>
          </div>
        </form>
        <form v-if="showForgotPassword" @submit.prevent class="password-reset">
          <div v-if="!passwordResetSuccess">
            <h1>Reset Password</h1>
            <p>We will send you an email to reset your password</p>

            <label for="email3">Email</label>
            <v-text-field
              v-model.trim="passwordForm.email"
              type="text"
              placeholder="you@email.com"
              id="email3"
            />

            <button @click="resetPassword" class="button">Submit</button>

            <div class="extras">
              <a @click="togglePasswordReset">Back to Log In</a>
            </div>
          </div>
          <div v-else>
            <h1>Email Sent</h1>
            <p>check your email for a link to reset your password</p>
            <button @click="togglePasswordReset" class="button">
              Back to login
            </button>
          </div>
        </form>
        <transition name="fade">
          <div v-if="errorMsg !== ''" class="error-msg">
            <p>{{ errorMsg }}</p>
          </div>
        </transition>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";
const fb = require("../firebaseConfig.js");

export default {
  data() {
    return {
      loginForm: {
        email: "",
        password: ""
      },
      signupForm: {
        name: "",
        email: "",
        password: ""
      },
      passwordForm: {
        email: ""
      },
      showLoginForm: true,
      showForgotPassword: false,
      passwordResetSuccess: false,
      performingRequest: false,
      errorMsg: ""
    };
  },
  computed: {
    ...mapState(["currentUser"])
  },
  methods: {
    toggleForm() {
      this.errorMsg = "";
      this.showLoginForm = !this.showLoginForm;
    },
    togglePasswordReset() {
      if (this.showForgotPassword) {
        this.showLoginForm = true;
        this.showForgotPassword = false;
        this.passwordResetSuccess = false;
      } else {
        this.showLoginForm = false;
        this.showForgotPassword = true;
      }
    },
    login() {
      this.performingRequest = true;
      fb.auth
        .signInWithEmailAndPassword(
          this.loginForm.email,
          this.loginForm.password
        )
        .then(user => {
          this.$store.commit("setCurrentUser", user.user);
          this.$store.dispatch("fetchUserProfile");
          this.performingRequest = false;

          fb.messaging
            .requestPermission()
            .then(() => fb.messaging.getToken())
            .then(token => {
              console.log("TOKEN: " + token); // Receiver Token to use in the notification
              this.sendTokenToServer(token);
            })
            .catch(function(err) {
              console.log("Unable to get permission to notify.", err);
            });

          // Callback fired if Instance ID token is updated.
          fb.messaging.onTokenRefresh(() => {
            fb.messaging
              .getToken()
              .then(refreshedToken => {
                console.log("Token refreshed. Token: " + refreshedToken);
                this.sendTokenToServer(refreshedToken);
              })
              .catch(err => {
                console.log("Unable to retrieve refreshed token ", err);
              });
          });

          this.$router.push("/");
        })
        .catch(err => {
          console.log(err);
          this.performingRequest = false;
          this.errorMsg = err.message;
        });
    },
    signup() {
      this.performingRequest = true;
      fb.auth
        .createUserWithEmailAndPassword(
          this.signupForm.email,
          this.signupForm.password
        )
        .then(user => {
          this.$store.commit("setCurrentUser", user.user);
          // create user obj
          fb.usersCollection
            .doc(user.user.uid)
            .set({
              name: this.signupForm.name,
              email: this.signupForm.email
            })
            .then(() => {
              this.$store.dispatch("fetchUserProfile");
              this.performingRequest = false;

              fb.messaging
                .requestPermission()
                .then(() => fb.messaging.getToken())
                .then(token => {
                  console.log("TOKEN: " + token); // Receiver Token to use in the notification
                  this.sendTokenToServer(token);
                })
                .catch(function(err) {
                  console.log("Unable to get permission to notify.", err);
                });

              // Callback fired if Instance ID token is updated.
              fb.messaging.onTokenRefresh(() => {
                fb.messaging
                  .getToken()
                  .then(refreshedToken => {
                    console.log("Token refreshed. Token: " + refreshedToken);
                    this.sendTokenToServer(refreshedToken);
                  })
                  .catch(err => {
                    console.log("Unable to retrieve refreshed token ", err);
                  });
              });

              this.$router.push("/");
            })
            .catch(err => {
              console.log(err);
              this.performingRequest = false;
              this.errorMsg = err.message;
            });
        })
        .catch(err => {
          console.log(err);
          this.performingRequest = false;
          this.errorMsg = err.message;
        });
    },
    resetPassword() {
      this.performingRequest = true;
      fb.auth
        .sendPasswordResetEmail(this.passwordForm.email)
        .then(() => {
          this.performingRequest = false;
          this.passwordResetSuccess = true;
          this.passwordForm.email = "";
        })
        .catch(err => {
          console.log(err);
          this.performingRequest = false;
          this.errorMsg = err.message;
        });
    },
    sendTokenToServer(token) {
      this.performingRequest = true;
      fb.usersCollection
        .doc(this.currentUser.uid)
        .update({
          FCMToken: token
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style lang="scss">
@import "../assets/scss/_global.scss";

#login {
  @media screen and (max-width: 742px) {
    height: 100vh;
    background: $white;
  }

  .col1,
  .col2 {
    height: 100vh;
    padding-top: 30vh;

    @media screen and (max-width: 742px) {
      height: auto;
      padding-top: 20vh;
    }
  }
  .col1 {
    color: $white;
    @media screen and (max-width: 742px) {
      display: none;
    }

    p {
      max-width: 490px;
      margin-top: 2rem;
      line-height: 1.8;
    }

    a {
      color: $white;
      text-decoration: underline;
    }
  }
  .signup-form {
    padding-top: 20vh;

    @media screen and (max-width: 742px) {
      padding-top: 10vh;
    }
  }
  .col2 {
    h1 {
      margin-bottom: 2rem;
    }
    form {
      max-width: 450px;
      margin: 0 auto;
    }
    .extras {
      float: right;
      text-align: right;
      a {
        display: block;
        margin-bottom: 0.5rem;
      }
    }

    .password-reset {
      h1 {
        margin-bottom: 1rem;
      }
      p {
        margin-bottom: 2rem;
      }
    }
  }
}
</style>
